module.exports = __webpack_public_path__ + "static/media/20-previsoes-para-2020.6cd3043a.mp4";